import { Box, Button, HStack } from '@chakra-ui/react';

interface OrderDetailActionsMobileProps {
  onNavigateHome: () => Promise<void> | void;
  onNavigateMyOrder: () => Promise<void> | void;
  isLoading: boolean;
}

export const OrderDetailActionsMobile = ({
  onNavigateHome,
  onNavigateMyOrder,
  isLoading,
}: OrderDetailActionsMobileProps) => (
  <Box
    width="100%"
    position="fixed"
    bgColor="white"
    bottom="0"
    backgroundColor="white"
    zIndex={99}
    p="2"
  >
    <HStack spacing="2" w="full" pb="8" pt="2" justifyContent="center">
      <Button
        variant="outline"
        flex="1"
        minW={0}
        onClick={() => {
          void onNavigateHome();
        }}
        isLoading={isLoading}
      >
        <span>Beranda</span>
      </Button>
      <Button
        variant="solid"
        flex="1"
        minW={0}
        onClick={() => {
          void onNavigateMyOrder();
        }}
        isLoading={isLoading}
      >
        <span>Riwayat Pesanan</span>
      </Button>
    </HStack>
  </Box>
);
